// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7vCv6","label":"styles_label__1M-D2"};